'use client';

import { c as _c } from "react/compiler-runtime";
import { parseAsString, useQueryState } from 'nuqs';
import { useCallback } from 'react';
import type { PRTabValue } from './types';
import { PR_TABS } from './types';

/**
 * Hook that provides centralized tab navigation state management
 * Uses URL query parameters via nuqs for persistence
 */
export function usePrTabNavigationStore(t0) {
  const $ = _c(15);
  const defaultTab = t0 === undefined ? PR_TABS.CHANGES : t0;
  let t1;
  if ($[0] !== defaultTab) {
    t1 = parseAsString.withDefault(defaultTab).withOptions({
      history: "push"
    });
    $[0] = defaultTab;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [activeTab, setTabState] = useQueryState("tab", t1);
  const typedActiveTab = activeTab as PRTabValue;
  let t2;
  if ($[2] !== setTabState) {
    t2 = value => {
      setTabState(value);
    };
    $[2] = setTabState;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setActiveTab = t2;
  let t3;
  if ($[4] !== setActiveTab) {
    t3 = () => {
      setActiveTab(PR_TABS.DISCUSSION);
    };
    $[4] = setActiveTab;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const switchToDiscussionTab = t3;
  let t4;
  if ($[6] !== setActiveTab) {
    t4 = () => {
      setActiveTab(PR_TABS.CHANGES);
    };
    $[6] = setActiveTab;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const switchToChangesTab = t4;
  const t5 = typedActiveTab === PR_TABS.DISCUSSION;
  const t6 = typedActiveTab === PR_TABS.CHANGES;
  let t7;
  if ($[8] !== setActiveTab || $[9] !== switchToChangesTab || $[10] !== switchToDiscussionTab || $[11] !== t5 || $[12] !== t6 || $[13] !== typedActiveTab) {
    t7 = {
      activeTab: typedActiveTab,
      setActiveTab,
      switchToDiscussionTab,
      switchToChangesTab,
      isDiscussionTab: t5,
      isChangesTab: t6
    };
    $[8] = setActiveTab;
    $[9] = switchToChangesTab;
    $[10] = switchToDiscussionTab;
    $[11] = t5;
    $[12] = t6;
    $[13] = typedActiveTab;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}